import {useMemo} from 'react'
import useOrderbook from './useOrderbook'

function useOrderbookMedian (symbol, tickSize, limit = 19) {
  const asks = useOrderbook({
    symbol,
    type: 'ask',
    tickSize,
    limit,
    mergeDesc: false,
    orderDesc: true
  })

  const bids = useOrderbook({
    symbol,
    type: 'bid',
    tickSize,
    limit,
    mergeDesc: true,
    orderDesc: true
  })

  return useMemo(() => {
    if (asks && bids) {
      const sorted = asks.concat(bids).sort((a, b) => a.amount - b.amount)
      const medianIdx = ((sorted.length * 2) / 3) >>> 0
      const median = sorted[medianIdx]?.amount
      return median
    }
    return 0
  }, [asks, bids])
}

export default useOrderbookMedian
